import "./App.css";
import React, { useEffect, useState, Suspense } from "react";
import { connect } from "react-redux";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import keys from "./store/keys";
import { setKey, getKey, clearKeys } from "./store/actions";
import Header from "./components/Header";
import Loading from "./components/Loading";
import Home from "./components/Home";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Activate from "./components/Activate";
import ForgetPassword from "./components/ForgetPassword";
import ResetPassword from "./components/ResetPassword";
import ProductDetails from "./components/ProductDetails";
import Wishlist from "./components/Wishlist";
import Cart from "./components/Cart";
import Manage from "./components/Manage";
import Footer from "./components/Footer";

function App({ session, setKey }) {
	return (
		<BrowserRouter>
			<Header />
			<div className="container-fluid mb-100">
				{session.isLoading && <Loading />}
				<Switch>
					<Route exact path="/signup" component={Signup} />
					<Route exact path="/login" component={Login} />
					<Route exact path="/fp" component={ForgetPassword} />
					<Route exact path="/rp" component={ResetPassword} />
					<Route exact path="/activate" component={Activate} />
					<Route exact path="/" component={Home} />
					<Route exact path="/products/:productId" component={ProductDetails} />
					<Route exact path="/wishlist" component={Wishlist} />
					<Route exact path="/cart" component={Cart} />
					<Route path="/manage" component={Manage} />
				</Switch>
			</div>
			<Footer />
		</BrowserRouter>
	);
}

const mapStateToProps = (store) => ({
	session: store.session,
});

const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
	getKey: (key) => dispatch(getKey(key)),
	clearKeys: () => dispatch(clearKeys()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
